import { readBuffer, writeBuffer } from '../../../../../utils';
import { getSignalsPaginationPageNo } from '../SignalsPagination';
import { getActiveSignalsTableTab } from '../Tabs/TabItem';

export const SIGNALS_LIST_LOCATION = 'SIGNALS_LIST_LOCATION';

export function saveSignalsListLocation() {
  const page = getSignalsPaginationPageNo();
  const tab = getActiveSignalsTableTab();

  writeBuffer(SIGNALS_LIST_LOCATION, {
    page,
    tab,
  });
}

export function getSignalsListLocation() {
  return readBuffer(SIGNALS_LIST_LOCATION);
}

export function removeSignalsListLocation() {
  sessionStorage.removeItem(SIGNALS_LIST_LOCATION);
}
